import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AmountWithCurrency } from 'src/shared/components/atoms/amountWithCurrency';
import { Invoice } from '../models/invoice';
import { InvoiceRow } from '../models/invoiceRow';

type InvoiceRowsTableProps = {
  invoice: Invoice;
};

// Mappa inte ut om rows är tomt - datat i API:et får fixas så vi inte behöver kolla customers-arrayen
// Vi grupperar inga rader nu
export const InvoiceRowsTable = (props: InvoiceRowsTableProps) => {
  const { invoice } = props;
  const { t } = useTranslation();
  // const [groupedRows, setGroupedRows] = useState<any[]>([]);
  const [rows, setRows] = useState<InvoiceRow[]>([]);
  const [totalSum, setTotalSum] = useState<number>(0);

  useEffect(() => {
    if (invoice.rows) {
      setRows(invoice.rows);
      const totalAmountSum = invoice.rows.reduce((accumulator, currentRow) => {
        return accumulator + currentRow.amount;
      }, 0);
      setTotalSum(totalAmountSum);
    } else {
      setRows([]);
    }
  }, [invoice]);

  return (
    <Grid item xs={12} mb={4}>
      {rows && rows?.length > 0 && (
        <TableContainer>
          <Table sx={{ width: '100%' }} aria-label='invoice table'>
            <TableHead>
              <TableRow>
                <TableCell colSpan={4} sx={{ fontWeight: '500', fontSize: 16 }}>
                  {t('invoice:article.description')}
                </TableCell>
                <TableCell sx={{ fontWeight: '500', fontSize: 16 }} align='right'>
                  {t('invoice:article.sum')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell colSpan={4} sx={{ fontSize: 16 }}>
                    {row.text}
                  </TableCell>
                  <TableCell sx={{ fontSize: 16 }} align='right'>
                    <AmountWithCurrency amount={row.amount} />
                  </TableCell>
                </TableRow>
              ))}
              <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell colSpan={4} />
                <TableCell sx={{ fontWeight: '500', fontSize: 18 }} align='right'>
                  {t('invoice:article.toPay')}: <AmountWithCurrency amount={totalSum} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};
